var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "mt-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des données sur mes documents")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Les informations que vous choisissez d'afficher sur vos documents seront également affichées sur les documents de vos collaborateurs n'ayant pas accès aux préférences générales."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.document,
            callback: function($$v) {
              _vm.document = $$v
            },
            expression: "document"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "identity" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon identité (prénom et nom)")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "email" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon adresse email")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "phone" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de ligne directe")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "parent" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher le document parent sur le pdf"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "mobile" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de portable")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "fax" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon numéro de fax")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "address" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mon adresse")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Vous pouvez ensuite modifier ces préférences lors de l'édition de documents"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des colonnes")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Les mentions que vous souhaitez afficher ou non par défaut sur vos documents pourront être réglées en fonction de vos clients (dans les préférences de chacun de vos clients) et pour chaque document."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.column,
            callback: function($$v) {
              _vm.column = $$v
            },
            expression: "column"
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "reference" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Référence")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.shouldShowDescription
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("el-checkbox", { attrs: { label: "description" } }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.__("Afficher la colonne Description"))
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "unit" } }, [
                  _vm._v(
                    _vm._s(_vm.$l10n.__("Afficher la colonne prix unitaire"))
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "vat" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne TVA")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "quantity" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Quantité")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "paymentDate" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la date de validité")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "totals" } }, [
                  _vm._v(
                    _vm._s(_vm.$l10n.__("Afficher les totaux du document"))
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "taxes" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher les taxes du document")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "taxFree" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Montant")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "image" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Image")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "discount" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher la colonne Remise")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "payment" } }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Afficher les infos de Paiement")))
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "explain" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Vous pouvez activer le masquage des informations tarifaires sur vos bons de livraison. Celui ci sera prioritaire par rapport au masquage des colones défini ci dessus."
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "priceOnDelivery" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__(
                        "Afficher les informations tarifaires sur les bons de livraisons"
                      )
                    )
                  )
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "explain" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Vous pouvez choisir d'afficher par défaut vos coordonnées bancaire sur tous vos documents (cette préférence est modifiable par document"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "bankAccount" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__(
                        "Afficher par défaut mes coordonnées bancaires sur les documents"
                      )
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("el-checkbox", { attrs: { label: "checkOrder" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__(
                        "Afficher par défaut mon libellé de chèque sur les documents"
                      )
                    )
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Précision des colonnes de documents")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.prefMessage) } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "label-input" },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$l10n.__("Précision de la colonne quantité")))
          ]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "inline",
              model: {
                value: _vm.precision,
                callback: function($$v) {
                  _vm.precision = $$v
                },
                expression: "precision"
              }
            },
            _vm._l(_vm.precisionList, function(value) {
              return _c("el-option", {
                key: value,
                attrs: { label: _vm.formatPrecision(value), value: value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des informations produits")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.catalog,
            callback: function($$v) {
              _vm.catalog = $$v
            },
            expression: "catalog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "number" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le nombre de produits du document sur le PDF"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "weight" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le poids des produits du document sur le PDF"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "default" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__("Afficher les paramètres de lignes par défaut")
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Affichage des informations client")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.third,
            callback: function($$v) {
              _vm.third = $$v
            },
            expression: "third"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "contact" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher par défaut le nom du contact client sur le PDF"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "signatureOnDelivery" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la signature du client sur les bons de livraison"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "signatureOnOrder" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la signature du client sur les bons de commande"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "signatureOnEstimate" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la signature du client sur les devis"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "phone" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher numéro de téléphone du client"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "vat" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le numéro de TVA intra du client sur le document"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "siret" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le numéro de siret du client sur le document"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "siren" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher le numéro de siren du client sur le document"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "reference" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Afficher la référence du client sur le document"
                    )
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Libellé de votre interlocuteur")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "label-input" },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$l10n.__("Libellé de votre interlocuteur")))
          ]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "inline",
              model: {
                value: _vm.speaker,
                callback: function($$v) {
                  _vm.speaker = $$v
                },
                expression: "speaker"
              }
            },
            _vm._l(_vm.speakerList, function(value, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: value.value, value: index }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.edit"),
              type: "tertiary",
              onclick: "Prefs.editValuesList('docspeakers');"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__("Affichage des codes barres sur les documents")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Vous pouvez choisir d’afficher les codes barres ainsi que les images de ceux-ci à la suite de la description de vos produits."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.barcode,
            callback: function($$v) {
              _vm.barcode = $$v
            },
            expression: "barcode"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "value" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Ajouter les valeurs de codes barres dans la description des produits"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "image" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Ajouter les codes barres dans la description des produits"
                    )
                  )
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c("doc-page-footer-pref", {
            attrs: { langs: _vm.langs },
            model: {
              value: _vm.footerAuto,
              callback: function($$v) {
                _vm.footerAuto = $$v
              },
              expression: "footerAuto"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }